import React, { useState } from "react";
import { costoProveedorDe, esCobrable, precioDe, tieneCosto, unidadDe, variantesDe } from "../../utils/catalogo";
import ServicioCreateDialog from "../servicios/ServicioCreateDialog";
import { ACCENT, BTN_PRIMARIO_SM, fmtMoney } from "./shared";
import {
  PlusIcon
} from "@heroicons/react/20/solid";

// ---------- Servicios y costos tab ----------
// La tarifa ya no vive en el proveedor (FRA-349): cada servicio del catálogo
// que este proveedor da trae su propia estructura de costo, y eso es lo que
// se contrata al asignarlo a un evento. Aquí solo se listan; el costo y su
// historial se editan en la ficha de cada servicio.
const ServiciosTab = ({ proveedor, servicios, navigate, soloLectura = false }) => {
  const [createOpen, setCreateOpen] = useState(false);

  // Solo lectura (P-FRA-13): sin alta de servicios desde la ficha.
  const botonAgregar = soloLectura ? null : (
    <button
      type="button"
      onClick={() => setCreateOpen(true)}
      className={BTN_PRIMARIO_SM}
      style={{ backgroundColor: ACCENT }}
    >
      <PlusIcon className="h-3.5 w-3.5" />
      Agregar servicio
    </button>
  );

  return (
    <div className="space-y-5">
      <div className="rounded-xl border border-zinc-200 dark:border-zinc-700/60 bg-white dark:bg-zinc-800/50 shadow-sm p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-xs uppercase tracking-wide font-semibold text-zinc-500">
              Servicios que da
            </div>
            <p className="mt-1 text-xs text-zinc-500">
              Al asignar este proveedor a un evento eliges cuál de estos
              servicios contratas; su costo se registra automáticamente como
              costo del evento, en estado &ldquo;por pagar&rdquo;.
            </p>
          </div>
          {botonAgregar}
        </div>

        {servicios.length === 0 ? (
          <div className="mt-4 text-sm text-zinc-500">
            Este proveedor todavía no tiene servicios en el catálogo.
          </div>
        ) : (
          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wide text-zinc-400">
                  <th className="pb-2 font-semibold">Servicio</th>
                  <th className="pb-2 font-semibold text-right">Te cuesta</th>
                  <th className="pb-2 font-semibold text-right">Cobras</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-100 dark:divide-zinc-700/40">
                {servicios.map((c) => {
                  const nVariantes = variantesDe(c).length;
                  const costo = tieneCosto(c)
                    ? `${fmtMoney(costoProveedorDe(c))} / ${unidadDe(c)}`
                    : null;
                  const cobro = esCobrable(c) ? precioDe(c) : null;
                  return (
                    <tr key={c.id}>
                      <td className="py-2 pr-3">
                        <button
                          type="button"
                          onClick={() => navigate(`/dashboard/servicios/${c.id}`)}
                          className="font-medium text-zinc-900 dark:text-zinc-100 hover:underline text-left"
                        >
                          {c.nombre || "(sin nombre)"}
                        </button>
                        {nVariantes > 0 && (
                          <span className="ml-2 text-xs text-zinc-400">
                            {nVariantes} {nVariantes === 1 ? "variante" : "variantes"}
                          </span>
                        )}
                      </td>
                      <td className="py-2 pr-3 text-right whitespace-nowrap">
                        {costo ?? <span className="text-zinc-300">—</span>}
                      </td>
                      <td className="py-2 text-right whitespace-nowrap">
                        {cobro != null ? (
                          `${fmtMoney(cobro)} / ${unidadDe(c)}`
                        ) : (
                          <span className="text-zinc-300">—</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <p className="mt-4 text-xs text-zinc-500 border-t border-zinc-100 dark:border-zinc-700/40 pt-3">
          El historial del costo de cada servicio vive en su ficha.
        </p>
      </div>

      {!soloLectura && (
      <ServicioCreateDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        inicial={{ deProveedor: true, proveedorId: proveedor.id }}
        onCreated={(id) => navigate(`/dashboard/servicios/${id}`)}
      />
      )}
    </div>
  );
};

export default ServiciosTab;
